import React from "react"
import PropTypes from "prop-types"

import ProgramImage from "./ProgramDetails/ProgramImage"
import classes from "./FitnessPreview.module.scss"
import ProgramTags from "./ProgramDetails/Tags/ProgramTags"
import SaveIcon from "./ProgramDetails/SaveIconSvg"
import OptimallyMeIconSvg from "./ProgramDetails/OptimallyMeIconSvg"
import ProgramOverview from "./ProgramOverview"
import ProgramHighlights from "./ProgramHighlights"
import ProgramDays from "./ProgramDays/ProgramDays"
import EquipmentAndMuscles from "./EquipmentDetails/EquipmentAndMuscles"
import DurationAndCoach from "./ProgramDetails/DurationAndCoach/DurationAndCoach"

const ProgramLevels = [
    "Advanced",
    "Beginner",
    "Challenger",
    "Intermediate",
]
const PROGRAM_LEVEL_NUMBER = 'number';
const DAYS_IN_WEEK = 7
export const ProgramDurationInWeeks = (program) => {
    return program?.programDays.length % DAYS_IN_WEEK === 0
        ? program?.programDays.length / DAYS_IN_WEEK
        : Math.floor(program?.programDays.length / DAYS_IN_WEEK);
};

export default function FitnessPreview({ program = {} }) {
    const imageUrl =
        program.file?.[0]?.preview ??
        program.file?.[0]?.link ??
        '';

    const levelText =
        typeof program.programLevel === PROGRAM_LEVEL_NUMBER
            ? ProgramLevels[program.programLevel - 1] || ''
            : '';

    const tags = [
        levelText,
        ...(Array.isArray(program.tagNames) ? program.tagNames : []),
    ].filter(Boolean);

    const name = program.name || '';
    const coach = program.coach || {};

    const coachName = program.coach?.name || '';
    const programOverview = program.overview || '';
    const programHighlights = program.highlights || '';
    const wellnessProgramDays = program.programDays || '';

    return (
        <div id="preview" className={classes.previewContainer}>

            <ProgramImage imageUrl={imageUrl} />

            <div className={classes.tagsAndSave}>
                <ProgramTags tags={tags} />
                <SaveIcon />
            </div>

            <div className="tw-flex tw-items-center tw-justify-center tw-gap-2">
                <h1 className={classes.programName}>{name}</h1>
                <OptimallyMeIconSvg />
            </div>

            <DurationAndCoach coachName={coachName} programDuration={ProgramDurationInWeeks(program)} coachImageUrl={coach?.file?.link} />

            <div className="tw-flex tw-flex-row tw-gap-3 tw-justify-center">
                <div className={classes.pill}>View Reports</div>
                <div className={classes.pill}>Explore</div>
            </div>

            <ProgramOverview overview={programOverview} />
            <EquipmentAndMuscles wellnessDays={wellnessProgramDays} />
            <ProgramHighlights highlights={programHighlights} />
            <ProgramDays wellnessDays={wellnessProgramDays} />

            <div className={classes.startProgramWrapper}>
                <button className={classes.startProgramButton}>
                    Start program
                </button>
            </div>
        </div>

    )
}

FitnessPreview.propTypes = {
    program: PropTypes.shape({
        name: PropTypes.string,
        programLevel: PropTypes.number,
        file: PropTypes.arrayOf(
            PropTypes.shape({
                preview: PropTypes.string,
                link: PropTypes.string,
            })
        ),
        tagNames: PropTypes.arrayOf(PropTypes.string),
    }),
}
